const comments = [
  {
    id: 1,
    name: '漫迷小明',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%2C%20warm%20coral%20tones%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20minimal%20illustration%20style%2C%20high%20detail%20character%20design&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '从大学开始就用九妖漫画网追漫了，下拉式阅读真的太爽了，一口气看几十话完全不累。推荐给所有喜欢看漫画的朋友！',
    time: '3天前',
    manga: '斗破苍穹',
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20warm%20pink%20and%20coral%20tones%2C%20simple%20cream%20background%2C%20happy%20expression%2C%20minimal%20illustration%20style%2C%20high%20detail%20character%20design&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '国漫专区的漫画越来越多了，质量也越来越高！以前都觉得国漫不行，现在每天追国漫比追日漫还勤快。免费的还能看到这么高清的画质，真的很良心。',
    time: '5天前',
    manga: '狐妖小红娘',
  },
  {
    id: 3,
    name: '追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20young%20man%20avatar%20portrait%2C%20warm%20amber%20tones%2C%20simple%20cream%20background%2C%20confident%20expression%2C%20minimal%20illustration%20style%2C%20high%20detail%20character&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '韩漫热门的更新速度没得说，昨天韩网刚更新今天这边就能看了。女神降临番外篇超甜！而且分类很全，玄幻、恋爱、悬疑什么类型都有。',
    time: '1周前',
    manga: '女神降临',
  },
  {
    id: 4,
    name: '漫评人老王',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20anime%20style%20man%20avatar%20portrait%2C%20warm%20coral%20tones%2C%20simple%20cream%20background%2C%20thoughtful%20expression%2C%20minimal%20illustration%20style%2C%20high%20detail%20character&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '作为看了十几年漫画的老漫迷，九妖漫画网的免费漫画全集模式确实颠覆了传统阅读方式。下拉式设计非常人性化，资源覆盖面也很广，国漫日漫韩漫都有。希望平台越做越好！',
    time: '2周前',
    manga: '海贼王',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者心声
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自九妖漫画网读者的真实评价，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200/50 transition-colors cursor-default"
            >
              <div className="flex items-start gap-4 mb-4">
                {/* Avatar */}
                <div className="w-11 h-11 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={`${comment.name} 头像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-semibold text-sm text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </h3>
                    <span className="px-2 py-0.5 text-xs bg-primary-50 text-primary-600 rounded-full whitespace-nowrap">
                      正在追《{comment.manga}》
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-0.5">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{comment.content}&rdquo;
              </p>
              {/* Stars */}
              <div className="flex items-center gap-0.5 mt-3 text-accent-500 text-sm">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}